module.exports = __webpack_public_path__ + "media/assets/good_at/aws-cc83e4a1637232943570dcac70d1e151.png";